import React from "react";

import { MascotFrame, skinTones } from "./MascotFrame";

export function MerlinArt({ className }: { className?: string }) {
  return (
    <MascotFrame
      className={className}
      backdropClassName="bg-mascot-backdrop-indigo"
    >
      <path d="M9 48c0-9 6.5-15 15-15s15 6 15 15z" className="fill-gray-500" />
      <path
        d="M13.5 36c-2-13 3-24 10.5-26 7.5 2 12.5 13 10.5 26z"
        className="fill-gray-500"
      />
      <path
        d="M16.5 33c-1-9 2.5-16 7.5-17.5 5 1.5 8.5 8.5 7.5 17.5z"
        className="fill-gray-700"
      />
      <circle cx="24" cy="25" r="6.3" className={skinTones.medium} />
      <path
        d="M17.5 25.5c0 3.5 1.3 5.5 2.6 6.8 1.4 2.4 2.7 7 3.9 11.7 1.2-4.7 2.5-9.3 3.9-11.7 1.3-1.3 2.6-3.3 2.6-6.8-1.8 2.2-4 3.2-6.5 3.2s-4.7-1-6.5-3.2z"
        className="fill-gray-100"
      />
      <path
        d="M20.3 28.6c1.4-1.2 2.7-1.2 3.7 0 1-1.2 2.3-1.2 3.7 0-1.2 1.1-2.6 1.3-3.7.4-1.1.9-2.5.7-3.7-.4z"
        className="fill-gray-300"
      />
      <circle cx="21.5" cy="24.8" r=".9" className="fill-gray-800" />
      <circle cx="26.5" cy="24.8" r=".9" className="fill-gray-800" />
      <path
        d="M19.6 22.9q1.7-1.2 3.4-.2m2 0q1.7-1 3.4.2"
        className="fill-none stroke-gray-100"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M16.5 33c1.5 1 3 1.6 4.5 2m11-2c-1.5 1-3 1.6-4.5 2"
        className="fill-none stroke-gray-600"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <circle cx="37" cy="38" r="5.5" className="fill-teal-300" />
      <circle
        cx="37"
        cy="38"
        r="3"
        className="fill-none stroke-white"
        strokeWidth="1"
      />
      <circle cx="37" cy="38" r="1" className="fill-white" />
      <path d="M33.5 43h7l1 2.5h-9z" className="fill-yellow-700" />
    </MascotFrame>
  );
}
